import LegalPage from "./LegalPage";

export default function Terms() {
  return (
    <LegalPage
      testId="terms-page"
      title="Terms"
      accent="of Service."
      effective="January 25, 2026"
      sections={[
        {
          heading: "Company Disclosure",
          body: [
            "JC3 Wealth Legacy Group LLC is a financial consulting firm. We do not guarantee specific results. Individual outcomes vary based on your financial profile, third-party institution criteria, and client cooperation. We are not a credit repair organization and we are not a lender or funding company.",
          ],
        },
        {
          heading: "Consumer Rights Disclosure",
          body: [
            "JC3 Wealth Legacy Group LLC provides financial consulting, education, and document preparation support. You have the right to dispute inaccurate information in your consumer file directly with consumer reporting agencies at no cost. You have the right to obtain a free copy of your consumer disclosure from annualcreditreport.com. Accurate information cannot be removed from your consumer file before the legally permitted retention period expires. JC3 does not guarantee any specific outcome, score change, or timeline.",
          ],
        },
        {
          heading: "Services Offered",
          body: [
            "JC3 Wealth Legacy Group LLC provides the following consulting and educational services:",
          ],
          bullets: [
            "Financial Profile Development — financial profile analysis and strategic guidance, including education on communicating with consumer reporting agencies yourself",
            "Business Capital Strategy — capital-readiness consulting and capital-source research",
            "Business Foundation Setup — entity selection and business structuring guidance",
            "Account History Positioning — strategy guidance and arrangement of authorized user additions on established accounts (no card or charging access is provided)",
            "Grant Readiness & Research — eligibility research and application preparation",
            "Personal Capital Strategy — personal financial strategy consulting and capital-readiness guidance (no financial products issued)",
          ],
        },
        {
          heading: "Nature of Services",
          body: [
            "All services are educational and consulting in nature. JC3 Wealth Legacy Group is not a law firm, accounting firm, credit repair organization, lender, funding company, registered investment advisor, or grant-writing agency of record. We do not provide legal advice, accounting advice, securities recommendations, credit repair services, loans, or financing of any kind. Engaging our services does not create an attorney-client, accountant-client, or fiduciary investment-advisor relationship.",
          ],
        },
        {
          heading: "No Guarantees",
          body: [
            "We make no guarantee of any specific score outcome, capital outcome, investment return, or business outcome. Results depend on your individual circumstances, your consistency in following recommended steps, and factors outside our control including bureau processing timelines and third-party institution decisioning.",
          ],
        },
        {
          heading: "Client Responsibilities",
          body: ["By engaging our services you agree to:"],
          bullets: [
            "Provide accurate and complete information",
            "Follow recommended action steps in a timely manner",
            "Notify us of material changes to your financial situation",
            "Understand that results depend in large part on your own actions",
          ],
        },
        {
          heading: "Payments and Processing Fee",
          body: [
            "Payments are processed via PaymentCloud and Authorize.net. A 3% processing fee applies to credit card payments. Debit card payments are not charged this fee. The Financial Profile Development onboarding fee is billed when your analysis and roadmap are delivered, and Business and Personal Capital Strategy fees are invoiced only after capital closes. Except for the cancellation rights described below, fees for services already performed are non-refundable. See our Refund Policy.",
          ],
        },
        {
          heading: "Your Cancellation Rights",
          body: [
            "You may cancel any service agreement with JC3 Wealth Legacy Group LLC, without penalty and for a full refund of any amounts paid, at any time within three (3) business days after the date you sign your engagement agreement. To cancel, email jace@jc3wealthlegacy.com with the subject line CANCEL before midnight of the third business day.",
            "For Financial Profile Development services, you are billed monthly in arrears: each monthly fee is charged only after that month's services have been performed. You may cancel Financial Profile Development at any time, effective at the end of the current service month, with no cancellation fee.",
          ],
        },
        {
          heading: "Refund Policy",
          body: [
            "Refunds are governed by our Refund Policy, available at /refund.",
          ],
        },
        {
          heading: "Intellectual Property",
          body: [
            "All content on jc3wealthlegacy.com — including frameworks, methodologies, written materials, video, and downloadable assets — is owned by JC3 Wealth Legacy Group LLC. You may not copy, redistribute, or resell our materials without express written permission.",
          ],
        },
        {
          heading: "Prohibited Conduct",
          body: ["You agree not to:"],
          bullets: [
            "Use our services or website for any unlawful purpose",
            "Attempt unauthorized access to any portion of our systems",
            "Resell, redistribute, or repurpose our consulting materials",
            "Misrepresent your identity or impersonate another person",
            "Take any action that damages the reputation of JC3 Wealth Legacy Group",
          ],
        },
        {
          heading: "Limitation of Liability",
          body: [
            "To the maximum extent permitted by law, JC3 Wealth Legacy Group LLC is not liable for any indirect, incidental, consequential, special, or punitive damages arising from your use of our services. Our total liability for any claim is capped at the total amount you paid us in the 90 days preceding the event giving rise to the claim.",
          ],
        },
        {
          heading: "Indemnification",
          body: [
            "You agree to defend, indemnify, and hold harmless JC3 Wealth Legacy Group LLC and its representatives from any claims, damages, or expenses arising from your violation of these Terms or your misuse of our services.",
          ],
        },
        {
          heading: "Dispute Resolution and Binding Arbitration",
          body: [
            "Any dispute, claim, or controversy arising out of or relating to these Terms or your use of our services will be resolved by binding arbitration administered by the American Arbitration Association under its Consumer Arbitration Rules. The arbitration will be seated in Fulton County, Georgia. Judgment on the award rendered by the arbitrator may be entered in any court of competent jurisdiction.",
            { html: "<strong>Small Claims Exception.</strong> Either party may bring an individual claim in small claims court in Fulton County, Georgia instead of arbitration, so long as the claim remains in that court." },
            { html: "<strong>JURY TRIAL WAIVER.</strong> YOU AND JC3 WEALTH LEGACY GROUP LLC EACH WAIVE THE RIGHT TO A TRIAL BY JURY." },
            { html: "<strong>CLASS ACTION WAIVER.</strong> ALL CLAIMS MUST BE BROUGHT IN THE PARTIES' INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. THE ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE PERSON'S CLAIMS." },
            { html: "<strong>Your Right to Opt Out.</strong> You may opt out of this arbitration agreement by sending written notice to jace@jc3wealthlegacy.com within 30 days of first accepting these Terms. Opting out of arbitration does not affect any other provision of these Terms." },
            { html: "<strong>Governing Law.</strong> These Terms are governed by the laws of the State of Georgia without regard to conflict of law principles." },
            { html: "<strong>Acknowledgment.</strong> By creating an account or using our services, you acknowledge that you have read and understood the JURY TRIAL WAIVER and CLASS ACTION WAIVER above, and you agree to resolve disputes as described in this section." },
          ],
        },
        {
          heading: "Contact",
          body: [
            { html: 'For questions about these Terms, contact us at <a class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold" href="mailto:jace@jc3wealthlegacy.com">jace@jc3wealthlegacy.com</a>.' },
            { html: 'JC3 Wealth Legacy Group LLC · Atlanta, Georgia · <a class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold" href="tel:+14708887331">470-888-7331</a>' },
          ],
        },
      ]}
    />
  );
}
